import React, { useEffect, useState } from "react";
import DropDownListComponent from "./DropDownListComponent";

const DropDownBooleanComponent = (props: any) => {
  const [model, setModel] = useState({})
  const optionBoolValues = [
    { label: 'Sim', value: true },
    { label: 'Não', value: false },
  ];

  useEffect(() => {
    let m = props.model;
    if (props.model == null || props.model['id'] == null || props.model['id'] == '') {
      if (props.model != null)
      {
        m[props.modelField] = false;
        setModel(m);
      }

      return;
    }

    m[props.modelField] = m[props.modelField] == 1;
    setModel(m);
  }, [props.model]);

  return (
    <div className={props.divClassName}>
      <DropDownListComponent
        label={props.label}
        type='bool'
        required={props.required}
        options={optionBoolValues}
        valueField='value'
        textField='label'
        model={model}
        modelField={props.modelField}
        setModelEventCallBack={props.setModelEventCallBack} />
    </div>
  )
}

export default DropDownBooleanComponent;